import { ColDef } from '@ag-grid-community/core'
import {
  NfColumnTypes,
  NfGridOptions,
  quantityFormatter,
} from '@northfork/ag-grid'

export const HsPreciseNumberColDef: ColDef = {
  ...(NfGridOptions.columnTypes?.[NfColumnTypes.Number] ?? {}),
  valueFormatter: quantityFormatter,
}
